<template>
  <div class="search-category-wrap">
    <div
      class="search-category-container"
      v-for="(tab, index) in tabs"
      :key="index"
      @click="clickCategoryTab(tab.name)"
      v-bind:class="{ active: activeTab === tab.name }"
    >
      {{ tab.text }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activeTab: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        {
          name: 'leaseOrSale',
          text: this.$t('find.LEASE_OR_SALE'),
        },
        {
          name: 'lease',
          text: this.$t('main.LEASE_STOCK'),
        },
        {
          name: 'sale',
          text: this.$t('main.BUY_STOCK'),
        },
        {
          name: 'tx',
          text: this.$t('main.TX'),
        },
        {
          name: 'agent',
          text: this.$t('main.DRAWER_AGENT'),
        },
      ],
    };
  },
  methods: {
    clickCategoryTab(val) {
      this.$emit('tabclicked', val);
    },
  },
};
</script>
<style scoped>
.search-category-wrap {
  display: flex;
  gap: 32px;
  font-size: 16px;
}

.search-category-container {
  padding-bottom: 2px;
  border-bottom: 4px transparent solid;
  cursor: pointer;
}

.search-category-container.active {
  border-color: #ffe100;
  font-weight: 700;
}
</style>
